/* eslint-disable sonarjs/no-duplicate-string */
export const ALL_FLOW_TYPES = [
  'curology-flow-signup',
  'curology-flow-signup-chia',
  'curology-flow-new-treatment-chia',
  'curology-flow-new-treatment-skin',
  'curology-flow-1-x-rx-new-patient-skin',
  'curology-flow-medical-history-update',
  'curology-flow-resubscription',
  'curology-flow-resubscription-non-expedited',
  'agency-flow-medical-history-update',
  'agency-flow-signup-skin',
  'agency-flow-signup-chia',
  'medical-history-update',
  'generic-checkin',
  'curology-flow-retail-one-time-skin',
] as const;

export type FlowType = (typeof ALL_FLOW_TYPES)[number];

const FLOW_TYPES = {
  SignupSkin: 'curology-flow-signup',
  SignupChia: 'curology-flow-signup-chia',
  NewTreatmentChia: 'curology-flow-new-treatment-chia',
  NewTreatmentSkin: 'curology-flow-new-treatment-skin',
  OneTimeRxSkin: 'curology-flow-1-x-rx-new-patient-skin',
  MedicalHistoryUpdate: 'curology-flow-medical-history-update',
  Resubscription: 'curology-flow-resubscription',
  ResubscriptionNonExpedited: 'curology-flow-resubscription-non-expedited',
  AgencyMedicalHistoryUpdate: 'agency-flow-medical-history-update',
  AgencySignupSkin: 'agency-flow-signup-skin',
  AgencySignupChia: 'agency-flow-signup-chia',
  GeneralMedicalHistoryUpdate: 'medical-history-update',
  GenericCheckin: 'generic-checkin',
  CurologyRetailOneTimeSkin: 'curology-flow-retail-one-time-skin',
} as const satisfies Record<string, FlowType>;

export const SignupFlowTypes = [
  FLOW_TYPES.SignupSkin,
  FLOW_TYPES.SignupChia,
  FLOW_TYPES.AgencySignupSkin,
];
export const NewTreatmentFlowTypes = [
  FLOW_TYPES.NewTreatmentChia,
  FLOW_TYPES.NewTreatmentSkin,
];

export default FLOW_TYPES;
